// One trade-history row in the fields the history list reads. Import-free CommonJS, so it can be
// tested in plain node -- see src/lib/exchange-families.js for the precedent.
//
// Kraken spot and Bybit send a fill's time in seconds, Binance in milliseconds. trading-api passes
// Binance's fills through as Binance sends them: the quantity in qty and the value in quoteQty, where
// the others send vol or size, and cost.
const MILLISECOND_TIME_EXCHANGES = ['binance'];

const uniformTradeRow = (exchange, row) => {
	if (row.time) {
		row.createdAt = MILLISECOND_TIME_EXCHANGES.includes(exchange) ? Number(row.time) : row.time * 1000;
	} else {
		row.createdAt = new Date(row.fillTime || row.createdAt).getTime();
	}
	row.execPriceRp = parseFloat(row.price);
	const quantity = parseFloat(row.vol) || parseFloat(row.qty) || parseFloat(row.size) || 0;
	row.execValueRv = parseFloat(row.cost) || parseFloat(row.quoteQty) || quantity * row.execPriceRp;
	row.tradeType = row.ordertype || row.tradeordertype || row.fillType || '';
	row.orderQtyRq = quantity;
	row.execQtyRq = quantity;
	return row;
};

module.exports = { uniformTradeRow };
